// extracted by mini-css-extract-plugin
export var copyIcon = "_yb-2";
export var discountCard = "_yb-0";
export var discountCode = "_yb-3";
export var discountContent = "_yb-1";
export var loadingCard = "_yb-4";